<h1>{{ data().status }}</h1>
<h2>{{ subHeading() }}</h2>
@if (action()) {
	<a [routerLink]="action().url">{{ action().label }}</a>
}
@if (data().data?.length > 0) {
	<div class="pnf-links">
		@for (entry of data().data.slice(0, 5); track entry) {
			<a href="" [routerLink]="entry" target="_self">{{ entry }}</a>
		}
		@if (data().data.length > 5) {
			<div>...</div>
		}
	</div>
}
